import React from 'react';
import { Helmet } from 'react-helmet-async';

export function DatenschutzPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-16" data-testid="page-datenschutz">
      <Helmet>
        <title>Datenschutz · PendelPilot</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <h1 className="font-display text-4xl md:text-5xl tracking-tighter">Datenschutzerklärung</h1>
      <p className="text-sm text-neutral-500 mt-2">Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}</p>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">1. Verantwortlicher</h2>
        <p className="text-neutral-700">
          Stefan Amirtharajah<br />
          Jahnstraße 7<br />
          52457 Aldenhoven<br />
          E-Mail: amirtharajah.stefan@gmail.com
        </p>
      </section>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">2. Grundsatz der Datensparsamkeit</h2>
        <p className="text-neutral-700">
          PendelPilot ist datensparsam konzipiert. Alle Berechnungen (Pendel-Score, Lebenszeit,
          Empfehlungen, Pendlerpauschale, Jobwechsel-Vergleich) erfolgen direkt in deinem Browser.
          Deine Eingaben (Strecke, Bürotage, Verbrauch, Gehalt etc.) werden <strong>nicht</strong> an
          unsere Server gesendet und nicht gespeichert.
        </p>
      </section>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">3. Verarbeitete Daten</h2>
        <h3 className="font-display text-lg mt-4">a) Spritpreis-Anfrage (PLZ / Standort)</h3>
        <p className="text-neutral-700">
          Wenn du die Funktion „Aktuellen Spritpreis laden" nutzt, übermitteln wir entweder deine
          eingegebene PLZ oder — bei Nutzung des Standort-Buttons — deine ungefähren Geokoordinaten
          an unseren Server. Von dort fragen wir die Schnittstelle Tankerkönig
          (creativecommons.tankerkoenig.de) ab. Die PLZ bzw. Koordinaten werden nicht dauerhaft
          gespeichert; lediglich zur Beschleunigung wird das Abfrage-Ergebnis bis zu 15 Minuten im
          Arbeitsspeicher gecacht. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
          Interesse an einer funktionierenden Dienstleistung).
        </p>

        <h3 className="font-display text-lg mt-4">b) PDF-Report mit optionaler E-Mail</h3>
        <p className="text-neutral-700">
          Beim PDF-Export kannst du <strong>freiwillig</strong> deine E-Mail-Adresse angeben. Diese
          wird zusammen mit deinem berechneten Score und den anonymisierten Eckdaten (Distanz,
          Jahreskosten) in unserer Datenbank gespeichert, um dir in Zukunft Updates senden zu können.
          Ohne E-Mail-Angabe wird nichts gespeichert. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO
          (Einwilligung). Du kannst deine Daten jederzeit per Mail an die oben genannte Adresse
          löschen lassen.
        </p>

        <h3 className="font-display text-lg mt-4">c) Server-Logs</h3>
        <p className="text-neutral-700">
          Unser Hoster speichert technisch erforderliche Zugriffsdaten (gekürzte IP-Adresse, Browser-Typ,
          Zeitpunkt, abgerufene URL) für maximal 14 Tage zur Abwehr von Angriffen. Rechtsgrundlage:
          Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h3 className="font-display text-lg mt-4">d) Cookies</h3>
        <p className="text-neutral-700">
          PendelPilot setzt selbst keine Tracking-Cookies. Es können technisch notwendige Cookies
          (z.B. Session-Cookies durch React-Routing) zum Einsatz kommen; diese sind nicht
          zustimmungspflichtig.
        </p>
      </section>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">4. Drittanbieter</h2>
        <ul className="list-disc pl-6 text-neutral-700 space-y-2">
          <li><strong>Tankerkönig</strong> (creativecommons.tankerkoenig.de) — wird bei Spritpreis-Abfragen aufgerufen. Datenschutzhinweise des Anbieters gelten zusätzlich.</li>
          <li><strong>Google Fonts / Fontshare</strong> — Schriften werden über CDN nachgeladen. IP-Adresse wird beim Laden übertragen.</li>
          <li><strong>Affiliate-Links</strong> — In Empfehlungen können Links zu Partnern (BlaBlaCar, Deutsche Bahn, ImmoScout24, heycar) enthalten sein. Erst beim Klick wirst du zur jeweiligen Drittseite weitergeleitet; deren Datenschutz gilt dort.</li>
        </ul>
      </section>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">5. Deine Rechte</h2>
        <p className="text-neutral-700">
          Du hast nach Art. 15–21 DSGVO das Recht auf Auskunft, Berichtigung, Löschung,
          Einschränkung der Verarbeitung, Datenübertragbarkeit, Widerspruch und Widerruf erteilter
          Einwilligungen. Beschwerderecht bei der für dich zuständigen Aufsichtsbehörde. Kontakt für
          alle Anfragen: amirtharajah.stefan@gmail.com.
        </p>
      </section>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">6. Speicherdauer</h2>
        <p className="text-neutral-700">
          E-Mail-Adressen aus dem PDF-Export werden bis zum Widerruf bzw. spätestens nach 24 Monaten
          gelöscht. Server-Logs nach 14 Tagen. Spritpreis-Cache nach 15 Minuten.
        </p>
      </section>
    </main>
  );
}

export function ImpressumPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-16" data-testid="page-impressum">
      <Helmet>
        <title>Impressum · PendelPilot</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <h1 className="font-display text-4xl md:text-5xl tracking-tighter">Impressum</h1>

      <section className="mt-10 space-y-2 text-neutral-700">
        <p className="text-xs uppercase tracking-widest text-neutral-500">Angaben gemäß § 5 TMG</p>
        <p className="mt-2">
          Stefan Amirtharajah<br />
          Jahnstraße 7<br />
          52457 Aldenhoven
        </p>
      </section>

      <section className="mt-8 space-y-2 text-neutral-700">
        <p className="text-xs uppercase tracking-widest text-neutral-500">Kontakt</p>
        <p>
          E-Mail: <a href="mailto:amirtharajah.stefan@gmail.com" className="underline">amirtharajah.stefan@gmail.com</a>
        </p>
      </section>

      <section className="mt-8 space-y-2 text-neutral-700">
        <p className="text-xs uppercase tracking-widest text-neutral-500">
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
        </p>
        <p>
          Stefan Amirtharajah<br />
          Jahnstraße 7<br />
          52457 Aldenhoven
        </p>
      </section>

      <section className="mt-10 space-y-3">
        <h2 className="font-display text-2xl">Haftungsausschluss</h2>
        <p className="text-neutral-700">
          Die Berechnungen auf PendelPilot dienen ausschließlich zur Orientierung und ersetzen
          keine individuelle Steuer-, Rechts- oder Finanzberatung. Trotz sorgfältiger inhaltlicher
          Kontrolle übernehmen wir keine Haftung für die Richtigkeit, Vollständigkeit und
          Aktualität der bereitgestellten Daten.
        </p>
        <h2 className="font-display text-2xl mt-6">Externe Links</h2>
        <p className="text-neutral-700">
          Diese Website enthält Links zu externen Seiten Dritter (u.&nbsp;a. Affiliate-Partner). Auf
          deren Inhalte haben wir keinen Einfluss; für deren Richtigkeit ist stets der jeweilige
          Anbieter verantwortlich.
        </p>
        <h2 className="font-display text-2xl mt-6">Verbraucherstreitbeilegung</h2>
        <p className="text-neutral-700">
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>
    </main>
  );
}
